export const ThemeEnum = {
  DARK: "dark",
  LIGHT: "light",
  TADBEER: "tadbeer",
} as const;

export type Theme = (typeof ThemeEnum)[keyof typeof ThemeEnum];

export const THEME_COLORS = {
  [ThemeEnum.DARK]: {
    bg: "bg-transparent",
    border: "#1C254B",
    moon: "#FFFFFF",
    sun: "#181F3C",
  },
  [ThemeEnum.LIGHT]: {
    bg: "bg-white",
    border: "#EAEAEA",
    moon: "#C4C4C4",
    sun: "#B3843E",
  },
  [ThemeEnum.TADBEER]: {
    bg: "bg-white",
    border: "#EAEAEA",
    moon: "#C4C4C4",
    sun: "#B3843E",
  },
} as const;
